import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";

import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { formatNumber } from "../../utils/numberFormatters";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const monthlyAverageTransactionsDefinition = defineDescriptionFilter({
    key: "monthlyAverageTransactions",
    apiCategory: leadsFilterApiCategory.monthlyAverageTransactions,
    category: leadsFilterCategoryMap.website,
    trackingName: "transactions",

    render: ({ description }) =>
        createRangeSelectFilter({
            key: "monthlyAverageTransactions",
            trackingName: "transactions",
            apiCategory: "leadsFilters",
            category: leadsFilterCategoryMap.website,

            translationKey: "monthlyTransactions",
            withTooltip: false,
            rangeOptions: {
                fieldName: "monthlyAverageTransactions",
                labelKey: leadsSearchFiltersI18nKeys.filterSummaryLabel("monthlyTransactions"),
                buckets: description.bucketsDescription.monthlyTransactions,
                formatValue: formatNumber,
            },
        }),
});
